import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';

const ParagraphArticleOverview = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const queryParams = new URLSearchParams(window.location.search);
  const subject = queryParams.get('field_subject_target_id');
  const defaultFilter = {};
  if (subject) {
    defaultFilter.field_subject_target_id = subject;
  }
  const [filters, setFilters] = useState(defaultFilter);

  return (
    <View
      id="recent_articles"
      display="overview"
      page={currentPage}
      filters={filters}
      setFilters={setFilters}
      setCurrentPage={setCurrentPage}
    />
  );
};

export default ParagraphArticleOverview;
